module.exports = __webpack_public_path__ + "static/media/ico_simulation_face_temple.5996210a.png";